<div *ngIf="isVisible" class="strip" (click)="onStripClicked()"  @fade>
    <bd-fa-button [name]="'check'"> </bd-fa-button> <span> {{message}} </span>
</div>

